import React from 'react';
import PropTypes from 'prop-types';
import SectionTitle from '../UpdateCustomerInfo/components/SectionTitle';
import UpdateCustomerInfo from '../UpdateCustomerInfo/components/UpdateCustomerInfo';

const Migration = props => (
  <UpdateCustomerInfo {...props}>
    <SectionTitle>Migration</SectionTitle>
    <p>Great news {props.customerName}! {props.brandName} is moving to Squire for booking appointments
       and offering memberships. Squire is the platform that has been adopted by some of
       the most successful businesses in the industry. To learn more about Squire click <a
         target="_blank"
         rel="noopener noreferrer"
         href="https://getsquire.com"
       >here</a>.
      </p>
    <br />
    <p>To continue your membership without any interruptions, you can add your credit
      card details to avoid any interruption of service. If you would like to wait,
      you can always ask the folks at {props.brandName} to help you update your membership
      during your next visit. Once your payment details are up to date, your membership
      will automatically become active.
    </p>
  </UpdateCustomerInfo>
);

Migration.propTypes = {
  customerName: PropTypes.string.isRequired,
  brandName: PropTypes.string.isRequired,
};

export default Migration;



// WEBPACK FOOTER //
// ./src/app/membership/Migration/Migration.jsx